import { render, staticRenderFns } from "./PanelKits.vue?vue&type=template&id=71357a60&scoped=true&"
import script from "./PanelKits.vue?vue&type=script&lang=js&"
export * from "./PanelKits.vue?vue&type=script&lang=js&"
import style0 from "./PanelKits.vue?vue&type=style&index=0&id=71357a60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71357a60",
  null
  
)

export default component.exports